import { createRouter, RouterProvider } from '@tanstack/react-router';
import {
  AddressSuggestionsProvider,
  ErrorState,
  mountApp,
  newQueryClient,
  setProblemTexts,
} from '@kanos/web-core';
import { routeTree } from './routeTree.gen';
import './styles.css';

// In the firm app, who may change what is a matter of the firm's administrators.
setProblemTexts({
  'access.denied': 'Dafür fehlt Ihnen die Berechtigung. Änderungen nehmen Admins der Kanzlei vor.',
});

const queryClient = newQueryClient();

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  // A new page starts at its top; back and forward return to where the person was. Only the
  // content scrolls in the frame (after Corly), so that is what goes back to the top.
  scrollRestoration: true,
  scrollToTopSelectors: ['#main-content'],
  defaultErrorComponent: ({ error, reset }) => (
    <ErrorState
      error={error}
      onRetry={() => {
        reset();
        void router.invalidate();
      }}
      onHome={() => void router.navigate({ to: '/' })}
    />
  ),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Every address the firm app asks for suggests while typed - the firm's own and its clients',
// from Kanos' own Photon (ADR-073).
mountApp(
  <AddressSuggestionsProvider audience="firm">
    <RouterProvider router={router} />
  </AddressSuggestionsProvider>,
  queryClient,
);
